import React from "react";
import {
  TextInput,
  TextField,
  SelectInput,
  LongTextInput,
  email,
  required,
  ImageField,
} from "admin-on-rest";
import CheckboxGroupInput from "../../components/form/CheckboxGroupInput";
import ImageOlaSingleInput from "../../components/image";
import DependentImageInput from "../../components/image/DependentImageInput";
import TabbedForm from "./TabbedForm";
import FormMain from "./FormMain";
import PartnerCodeField from "./PartnerCodeField";
import {
  dataStatusMarketer,
  dataCategory,
  marketerDefaultValue,
} from "../utilsMarketer";

const optionsStyle = {
  labelStyle: { width: 180 },
  style: {
    display: "flex",
    flex: "1 1 30%",
    flexDirection: "row",
    flexWrap: "wrap",
  },
};

export const EditMarketersForm = ({ permissions, ...props }) => {
  return (
    <TabbedForm {...props} defaultValue={marketerDefaultValue}>
      <FormMain label="main">
        <TextInput
          label="resources.marketers.fields.first_name"
          source="first_name"
          validate={[required]}
        />
        <TextInput
          label="resources.marketers.fields.last_name"
          source="last_name"
          validate={[required]}
        />
        <TextInput
          label="resources.marketers.fields.nickname"
          source="nickname"
          validate={[required]}
        />

        <PartnerCodeField
          {...props}
          label={"resources.marketers.fields.partner_id"}
          optionText="nickname"
          source={"partner_id"}
          optionValue="id"
        />
        <SelectInput
          label="resources.marketers.fields.status"
          source="status"
          choices={dataStatusMarketer}
        />
        <TextInput
          label="resources.marketers.fields.google_email"
          source="email"
          validate={[required, email]}
        />
        <TextInput label="resources.marketers.fields.mobile" source="mobile" />
        <TextInput
          label="resources.marketers.fields.profile"
          source="social.profile"
        />
        <DependentImageInput
          label="resources.marketers.fields.avatar"
          dependsOn={"nickname"}
          {...props}
        >
          <ImageOlaSingleInput
            source="avatarUrl"
            toValue={props.toValue}
            labelImage="Avatar"
            label={"resources.marketers.fields.avatar"}
            accept="image/*"
          >
            <ImageField source="src" title="title" />
          </ImageOlaSingleInput>
        </DependentImageInput>

        {props.permissions === "Admin" ? (
          <TextInput
            label="resources.marketers.banks.bank"
            source="custom1.bank"
          />
        ) : (
          <TextField
            label="resources.marketers.banks.bank"
            source="custom1.bank"
          />
        )}
        {props.permissions === "Admin" ? (
          <LongTextInput
            label="resources.marketers.banks.full_name"
            source="custom1.full_name"
          />
        ) : (
          <TextField
            label="resources.marketers.banks.full_name"
            source="custom1.full_name"
          />
        )}
        {props.permissions === "Admin" ? (
          <TextInput
            label="resources.marketers.banks.bank_account"
            source="custom1.account"
          />
        ) : (
          <TextField
            label="resources.marketers.banks.bank_account"
            source="custom1.account"
          />
        )}
        {props.permissions === "Admin" ? (
          <LongTextInput
            label="resources.marketers.banks.bank_branch"
            source="custom1.bank_branch"
          />
        ) : (
          <TextField
            label="resources.marketers.banks.bank_branch"
            source="custom1.bank_branch"
          />
        )}

        <TextInput
          label="resources.marketers.social.instagram"
          source="social.instagram.id"
        />
        <TextInput
          label="resources.marketers.social.facebook"
          source="social.facebook.id"
        />
        <TextInput
          label="resources.marketers.social.twitter"
          source="social.twitter.id"
        />
        <TextInput
          label="resources.marketers.social.youtube"
          source="social.youtube.id"
        />
        {/* <TextInput label="resources.marketers.social.followers" source="social.instagram.followers"/>
    <TextInput label="resources.marketers.social.followers" source="social.facebook.followers"/>
    <TextInput label="resources.marketers.social.followers" source="social.twitter.followers"/>
    <TextInput label="resources.marketers.social.followers" source="social.youtube.followers" /> */}
        <CheckboxGroupInput
          label=""
          source="custom3"
          choices={dataCategory}
          options={optionsStyle}
        />
      </FormMain>
    </TabbedForm>
  );
};



// WEBPACK FOOTER //
// ./src/marketers/form/EditMarketersForm.js